var chunkToChildrenMap = {
	"16368": [
		84781,
		89789,
		72448,
		47575,
		5783,
		22946,
		20794,
		15684,
		2406,
		56467,
		95656,
		41795,
		45062,
		65902,
		2289,
		62087,
		82631,
		68639,
		12044,
		95067,
		91460,
		81796,
		578,
		51672
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));